import * as React from "react";
import * as classnames from 'classnames';
import './Switch.css';

export interface SwitchProps {
    label?: string;
    isToggledOn: boolean;
    onChange: () => void;
}

export const Switch = ({ label, isToggledOn, onChange }: SwitchProps) => {
    const togglerClasses = classnames(
        'switch-toggle',
        `switch-toggle--${isToggledOn ? 'on' : 'off'}`
    )

    return (
        <>
            <div className="switch switch--small" onClick={onChange}>
                <div className={togglerClasses}></div>
                <label>{label}</label>
            </div>
        </>
    );
}
